import { useCreditsQuery } from "../query";

/**
 * Монетизація (credits + subscription) з одного глобального кешу React Query.
 * Той самий useCreditsQuery, що й useCreditsBalance / useGlobalMonetization.
 */
export const useMonetization = () => {
  const {
    data: credits,
    isLoading: loading,
    error,
    refetch,
  } = useCreditsQuery();

  const errorMessage =
    error instanceof Error ? error.message : error ? String(error) : null;

  return {
    credits: credits ?? null,
    subscription: credits?.subscription ?? null,
    loading,
    error: errorMessage,
    refetch,
  };
};

export default useMonetization;
